import React from "react";
import logo from "./logo.svg";
import "./App.css";

function App() {
  return <div className="App">Hello World</div>;
}

export default App;
